/**
 * Input số có phân tách hàng nghìn — parse/format qua numberFormat utils.
 */
import { formatNumberInput, parseFormattedNumber } from '../../shared/utils/numberFormat';

export const FormattedNumberInput = ({
  value,
  onValueChange,
  min,
  placeholder,
  required = false,
  allowDecimal = false,
  readOnly = false,
}) => (
  <input
    inputMode={allowDecimal ? 'decimal' : 'numeric'}
    min={min}
    placeholder={placeholder}
    required={required}
    readOnly={readOnly}
    value={formatNumberInput(value, allowDecimal)}
    onChange={(event) =>
      onValueChange(parseFormattedNumber(event.target.value, allowDecimal))
    }
  />
);
